/* eslint-disable no-param-reassign */
import React, { useState, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

/**
 * add a shim to server context
 * as this wizard would be used in different work flows, it many have different servercontext
 * i.e. smart-server-context, mca-server-context
 */
export const ServerContext = React.createContext([{}, _.noop]);

export const ServerContextProvider = (props) => {
  const [serverContext, setServerContext] = useState(props.serverContext);
  const updateServerContext = useCallback((newContext) => {
    setServerContext(prevState => ({
      ...prevState,
      ...newContext,
    }));
    newContext.CurrentAccount.Id = newContext.CurrentAccount.AccountId;
    newContext.CurrentCustomer.Id = newContext.CurrentCustomer.CustomerId;
    newContext.CurrentUser.Id = newContext.CurrentUser.UserId;
    newContext.CurrentUser.Name = newContext.CurrentUser.UserName;
    props.updateServerContext(newContext);
  }, [props]);

  return (
    <ServerContext.Provider value={[serverContext, updateServerContext]}>
      {props.children}
    </ServerContext.Provider >
  );
};

ServerContextProvider.propTypes = {
  serverContext: PropTypes.shape({}).isRequired,
  updateServerContext: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
